import React, { PureComponent, PropTypes } from 'react';
import { normalizeJaggedDataTable } from '../../services/Utils';
import Row from './tablerow';

class Table extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {};
    }

    render() {
        let { data, onBack, onCancel, onComplete } = this.props;

        let rows = normalizeJaggedDataTable(data)
        .map((row, index) => {
            return <Row
                { ...this.props }
                key={ index }
                values={ row }
            />;
        });

        return <div className="preview">
            <h1>Preview</h1>
            <div className="table horizontal">{ rows }</div>
            <div className="buttons">
                <button onClick={ onCancel }>Cancel</button>
                <button onClick={ onBack }>Back</button>
                <button onClick={ onComplete }>Next</button>
            </div>
        </div>;
    }
}

Table.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.arrayOf(
            PropTypes.string
        )
    ).isRequired,
    onBack: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/importer/preview.js